var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dash',{attrs:{"icon":"fa fa-refresh","titulo":"REABERTURAS DE ENTREGAS","subTitulo":"SGF GESTOR","qtd":_vm.qtd,"mostrarQtd":false,"loading":_vm.loading},nativeOn:{"click":function($event){return _vm.$router.push({ name: 'Gestores_SolicitacoesReaberturas' })}}})
}
var staticRenderFns = []

export { render, staticRenderFns }